import { oauthSessionPopupView } from './oauth-session-popup.view';
/**
 * Lightweight popup shown when the OAuth account button is clicked while already
 * signed in. Displays the current session details and offers a log-out button,
 * rather than starting a fresh sign-in flow. Self-contained: it creates its own
 * backdrop + container, appends them to `#main-container`, and tears everything
 * down on close.
 */
export class OauthSessionPopup {
    constructor(user, onLogOut) {
        this.onLogOut = onLogOut;
        this.parent = document.getElementById('main-container');
        if (!this.parent) {
            console.error('Can\'t find container for popup - "#main-container"');
            this.backdrop = null;
            return;
        }
        this.close = this.close.bind(this);
        this.onLogOutClick = this.onLogOutClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.backdrop = document.createElement('div');
        this.backdrop.className = 'popup-backdrop oauth-session-popup-backdrop';
        this.backdrop.appendChild(oauthSessionPopupView(user));
        this.handleEvents();
        this.parent.appendChild(this.backdrop);
    }
    handleEvents() {
        var _a;
        // Clicking the backdrop (outside the popup) or the close button dismisses it.
        this.backdrop.addEventListener('click', event => {
            const target = event.target;
            if (target === this.backdrop || target.closest('.overlay-button-close')) {
                this.close();
            }
        });
        (_a = this.backdrop.querySelector('.oauth-session-popup-logout')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', this.onLogOutClick);
        document.addEventListener('keydown', this.onKeyDown);
    }
    onLogOutClick(event) {
        event.stopPropagation();
        this.onLogOut();
        this.close();
    }
    onKeyDown(event) {
        if (event.key === 'Escape') {
            this.close();
        }
    }
    close() {
        var _a;
        document.removeEventListener('keydown', this.onKeyDown);
        (_a = this.backdrop) === null || _a === void 0 ? void 0 : _a.remove();
    }
}
